<template>
  <div>
    <v-autocomplete
      v-if="!preview"
      autocomplete="off"
      v-model="document_uuid"
      :label="$t('components.pickers.documentPicker.selectDocument')"
      :items="filteredDocumentsOptions"
      item-value="uuid"
      :search-input.sync="documentSearch"
      color="primary"
      @input.native="loadDocuments($route, false)"
      @change="addNewDocument()"
      required
      no-filter
      :disabled="disabled"
      class="mt-0 pt-0"
    >
      <template v-slot:item="{ item }">
        <span
          :id="item.uuid"
          v-intersect.quiet="{
            handler: infiniteScrolling,
          }"
        >
          {{ item.title }}
        </span>
        <v-spacer></v-spacer>
        <v-icon small class="mr-1" v-if="item.is_custom_document">
          mdi-star-outline
        </v-icon>
        <span>Add</span>
        <!-- <licence-chip
          :feature="
            disableAddingDocumentsWithoutAdvancedLicenceBasedOnFeature(
              item.crm_group
            )
          "
          :enabled="
            disableAddingDocumentsWithoutAdvancedLicenceBasedOnFeature(
              item.crm_group
            ).enabled
          "
          float-direction="right"
        ></licence-chip> -->
      </template>
      <!-- <template v-slot:append-item>
        <div
          v-intersect.quiet="{
            handler: infiniteScrolling,
          }"
        />
      </template> -->
    </v-autocomplete>

    <v-list v-for="(document, index) in filteredDocuments" :key="index">
      <document-component
        :document="document"
        :readonly="readonly"
        @delete-document="deleteDocument(document)"
      />
    </v-list>
  </div>
</template>

<script>
import DocumentComponent from "@/components/documents/DocumentComponent.vue";
import debounce from "@/plugins/debounce";
import api from "@/utils/api.js";
import LicenceChip from "@/components/general/LicenceChip";
import { mapGetters } from "vuex";

export default {
  name: "DocumentPicker",
  components: {
    DocumentComponent,
    // LicenceChip
  },
  props: {
    documents: {
      type: Array,
      default: Array,
    },
    unavailableDocuments: {
      type: Array,
      default: Array,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Boolean,
      default: false,
    },
    boatItems: {
      type: Array,
      default: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    feature: {
      type: String,
      default: String,
    },
  },
  data: () => ({
    documentSearch: "",
    isEditView: false,
    document_uuid: null,
    documentOptions: [],
    getUuid: null,
    nextUrl: null,
    timeout: null,
  }),
  created() {
    this.loadDocuments(this.$route, true);
  },
  watch: {
    filteredDocumentsOptions: {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["disableAddingDocumentsWithoutAdvancedLicenceHandler"]),
    filteredDocumentsOptions() {
      const boatItemDocumentUuids = this.boatItems.map((boatItem) =>
        boatItem.documents.map((document) => document.uuid)
      );

      const unavailableDocumentUuids = this.unavailableDocuments.map(
        (unavailableDocument) => {
          return typeof unavailableDocument.uuid !== "undefined"
            ? unavailableDocument.uuid
            : unavailableDocument;
        }
      );
      const documentUuids = this.documents.map((document) => document.uuid);

      const uuids = [
        ...boatItemDocumentUuids,
        ...unavailableDocumentUuids,
        ...documentUuids,
      ];

      return this.documentOptions.filter((option) => {
        return !option.is_present && !uuids.includes(option.uuid);
      });
    },
    filteredDocuments() {
      let documentsToDelete = [];
      let documentsToShow = [];
      if (
        this.$route.name === "modelsAdd" ||
        this.$route.name === "modelsEdit"
      ) {
        documentsToShow = this.documents.filter(
          (document) => !this.unavailableDocuments.includes(document.uuid)
        );
        documentsToDelete = this.documents.filter((document) =>
          this.unavailableDocuments.includes(document.uuid)
        );
        documentsToDelete.forEach((document) => this.deleteDocument(document));
      } else {
        documentsToShow = this.documents;
      }

      return documentsToShow;
    },
  },
  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
      if (entries[0].target.id === this.getUuid) {
        let path = this.nextUrl.split("/").splice(5, 5).join("/");
        api.getDocumentNextPage(path).then((resp) => {
          this.getNextPage(resp);
          this.documentOptions = [
            ...this.documentOptions,
            ...resp.data.results,
          ];
        });
      }
    },
    getNextPage(resp) {
      if (resp.data.next) {
        this.getUuid = resp.data.results[resp.data.results.length - 5].uuid;
        this.nextUrl = resp.data.next;
      } else {
        this.getUuid = null;
      }
    },
    disableAddingDocumentsWithoutAdvancedLicenceBasedOnFeature(
      group,
      item,
      view
    ) {
      return this.disableAddingDocumentsWithoutAdvancedLicenceHandler(
        this.feature
      )(group)(item, view);
    },
    addNewDocument() {
      const newDocument = this.documentOptions.find(
        (document) => document.uuid === this.document_uuid
      );
      this.$emit("add:document", {
        ...newDocument,
        is_disabled: true,
        is_editable: true,
        is_present: true,
        is_readable: true,
        is_removable: true,
      });

      this.$nextTick(() => {
        this.documentSearch = "";
        this.document_uuid = null;
      });
    },
    deleteDocument(document) {
      this.$emit("delete:document", this.documents.indexOf(document));
    },

    loadDocuments(route, initalLoad = false) {
      let fetchDocuments = () => {
        return new Promise((resolve, reject) => {
          this.documentSearch = this.documentSearch ? this.documentSearch : "";
          api
            .getDocumentList({
              search: this.documentSearch,
              crm_boat_uuid:
                ["boatsEdit", "boatsDetails"].indexOf(route.name) !== -1
                  ? route.params.id
                  : "",
            })
            .then((resp) => {
              this.getNextPage(resp);
              this.documentOptions = resp.data.results.map((item) => {
                return {
                  ...item,
                  disabled:
                    this.disableAddingDocumentsWithoutAdvancedLicenceBasedOnFeature(
                      item.crm_group,
                      item,
                      this.preview ? "details" : "edit"
                    ).disabled,
                };
              });
              resolve();
            });
        });
      };

      if (initalLoad) return fetchDocuments();

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        return fetchDocuments();
      }, 300); // delay
    },
  },
};
</script>
